import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../../modules/utility';

const apiBase = 'deviceTokenEvent';
//const idsField = 'deviceEventIds';

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			forceEmptySet: true,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const deviceTokenEventId = ownProps.deviceTokenEventId
		? ownProps.deviceTokenEventId
		: _.get(ownProps, ['match', 'params', 'deviceTokenEventId']);
	const deviceTokenEvent = _.get(state.maps, ['deviceTokenEvent', deviceTokenEventId]);

	console.log('state.lists', state.lists);

	let deviceTokenEvents = undefined;
	if (state.lists.deviceTokenEventIds) {
		deviceTokenEvents = _.map(
			state.lists.deviceTokenEventIds,
			(id) => state.maps.deviceTokenEvent[id]
		);
	}

	return {
		userMap: state.maps.user,
		deviceTokenEvent,
		deviceTokenEvents,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getDeviceTokenEvent: get,
			searchDeviceTokenEvents: search,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
